export const FETCH_DECLARATION_REQUEST = 'FETCH_DECLARATION_REQUEST';
export const FETCH_DECLARATION_SUCCESS = 'FETCH_DECLARATION_SUCCESS';
export const FETCH_DECLARATION_FAILURE = 'FETCH_DECLARATION_FAILURE';

export const CREATE_DECLARATION_REQUEST = 'CREATE_DECLARATION_REQUEST';
export const CREATE_DECLARATION_SUCCESS = 'CREATE_DECLARATION_SUCCESS';
export const CREATE_DECLARATION_FAILURE = 'CREATE_DECLARATION_FAILURE';

export const UPDATE_DECLARATION_REQUEST = 'UPDATE_DECLARATION_REQUEST';
export const UPDATE_DECLARATION_SUCCESS = 'UPDATE_DECLARATION_SUCCESS';
export const UPDATE_DECLARATION_FAILURE = 'UPDATE_DECLARATION_FAILURE';

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const FETCH_FILES_REQUEST = "FETCH_FILES_REQUEST";
export const FETCH_FILES_SUCCESS = "FETCH_FILES_SUCCESS";
export const FETCH_FILES_FAILURE = "FETCH_FILES_FAILURE";

export const DOWNLOAD_FILE_REQUEST = "DOWNLOAD_FILE_REQUEST";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "DOWNLOAD_FILE_FAILURE";

export const DELETE_FILE_REQUEST = "DELETE_FILE_REQUEST";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAILURE = "DELETE_FILE_FAILURE";

export const EDIT_DOCUMENT_REQUEST = 'EDIT_DOCUMENT_REQUEST';
export const EDIT_DOCUMENT_SUCCESS = 'EDIT_DOCUMENT_SUCCESS';
export const EDIT_DOCUMENT_FAILURE = 'EDIT_DOCUMENT_FAILURE';

export const SHARE_FILES_REQUEST = "SHARE_FILES_REQUEST";
export const SHARE_FILES_SUCCESS = "SHARE_FILES_SUCCESS";
export const SHARE_FILES_FAILURE = "SHARE_FILES_FAILURE";

export const FETCH_MESSAGE_REQUEST = "FETCH_MESSAGE_REQUEST";
export const FETCH_MESSAGE_SUCCESS = "FETCH_MESSAGE_SUCCESS";
export const FETCH_MESSAGE_FAILURE = "FETCH_MESSAGE_FAILURE";

export const FETCH_USER_SERVICES_REQUEST = "FETCH_USER_SERVICES_REQUEST";
export const FETCH_USER_SERVICES_SUCCESS = "FETCH_USER_SERVICES_SUCCESS";
export const FETCH_USER_SERVICES_FAILURE = "FETCH_USER_SERVICES_FAILURE";

export const ADD_USER_SERVICE_REQUEST = "ADD_USER_SERVICE_REQUEST";
export const ADD_USER_SERVICE_SUCCESS = "ADD_USER_SERVICE_SUCCESS";
export const ADD_USER_SERVICE_FAILURE = "ADD_USER_SERVICE_FAILURE";

export const ADD_USER_SERVICE_BATCH_REQUEST = "ADD_USER_SERVICE_BATCH_REQUEST";
export const ADD_USER_SERVICE_BATCH_SUCCESS = "ADD_USER_SERVICE_BATCH_SUCCESS";
export const ADD_USER_SERVICE_BATCH_FAILURE = "ADD_USER_SERVICE_BATCH_FAILURE";

export const DELETE_USER_SERVICE_REQUEST = "DELETE_USER_SERVICE_REQUEST";
export const DELETE_USER_SERVICE_SUCCESS = "DELETE_USER_SERVICE_SUCCESS";
export const DELETE_USER_SERVICE_FAILURE = "DELETE_USER_SERVICE_FAILURE";


export const FETCH_USER_SERVICES_DATA_REQUEST = "FETCH_USER_SERVICES_DATA_REQUEST";
export const FETCH_USER_SERVICES_DATA_SUCCESS = "FETCH_USER_SERVICES_DATA_SUCCESS";
export const FETCH_USER_SERVICES_DATA_FAILURE = "FETCH_USER_SERVICES_DATA_FAILURE";

export const CREATE_USER_SERVICES_DATA_REQUEST = "CREATE_USER_SERVICES_DATA_REQUEST";
export const CREATE_USER_SERVICES_DATA_SUCCESS = "CREATE_USER_SERVICES_DATA_SUCCESS";
export const CREATE_USER_SERVICES_DATA_FAILURE = "CREATE_USER_SERVICES_DATA_FAILURE";

export const UPDATE_USER_SERVICES_DATA_REQUEST = "UPDATE_USER_SERVICES_DATA_REQUEST";
export const UPDATE_USER_SERVICES_DATA_SUCCESS = "UPDATE_USER_SERVICES_DATA_SUCCESS";
export const UPDATE_USER_SERVICES_DATA_FAILURE = "UPDATE_USER_SERVICES_DATA_FAILURE";

export const DELETE_USER_SERVICES_DATA_REQUEST = "DELETE_USER_SERVICES_DATA_REQUEST";
export const DELETE_USER_SERVICES_DATA_SUCCESS = "DELETE_USER_SERVICES_DATA_SUCCESS";
export const DELETE_USER_SERVICES_DATA_FAILURE = "DELETE_USER_SERVICES_DATA_FAILURE";

export const SET_COMPLETE_USER_SERVICES_DATA_REQUEST = "SET_COMPLETE_USER_SERVICES_DATA_REQUEST";
export const SET_COMPLETE_USER_SERVICES_DATA_SUCCESS = "SET_COMPLETE_USER_SERVICES_DATA_SUCCESS";
export const SET_COMPLETE_USER_SERVICES_DATA_FAILURE = "SET_COMPLETE_USER_SERVICES_DATA_FAILURE";

export const GENERATE_USER_LETTER_REQUEST = 'GENERATE_USER_LETTER_REQUEST';
export const GENERATE_USER_LETTER_SUCCESS = 'GENERATE_USER_LETTER_SUCCESS';
export const GENERATE_USER_LETTER_FAILURE = 'GENERATE_USER_LETTER_FAILURE';

export const GENERATE_USER_LETTERS_REQUEST = 'GENERATE_USER_LETTERS_REQUEST';
export const GENERATE_USER_LETTERS_SUCCESS = 'GENERATE_USER_LETTERS_SUCCESS';
export const GENERATE_USER_LETTERS_FAILURE = 'GENERATE_USER_LETTERS_FAILURE';

export const FETCH_USER_LETTERS_REQUEST = 'FETCH_USER_LETTERS_REQUEST';
export const FETCH_USER_LETTERS_SUCCESS = 'FETCH_USER_LETTERS_SUCCESS';
export const FETCH_USER_LETTERS_FAILURE = 'FETCH_USER_LETTERS_FAILURE';

export const UPDATE_USER_LETTER_REQUEST = 'UPDATE_USER_LETTER_REQUEST';
export const UPDATE_USER_LETTER_SUCCESS = 'UPDATE_USER_LETTER_SUCCESS';
export const UPDATE_USER_LETTER_FAILURE = 'UPDATE_USER_LETTER_FAILURE';

export const FETCH_REFERENTS_REQUEST = 'FETCH_REFERENTS_REQUEST';
export const FETCH_REFERENTS_SUCCESS = 'FETCH_REFERENTS_SUCCESS';
export const FETCH_REFERENTS_FAILURE = 'FETCH_REFERENTS_FAILURE';

export const CREATE_REFERENT_REQUEST = 'CREATE_REFERENT_REQUEST';
export const CREATE_REFERENT_SUCCESS = 'CREATE_REFERENT_SUCCESS';
export const CREATE_REFERENT_FAILURE = 'CREATE_REFERENT_FAILURE';

export const UPDATE_REFERENT_REQUEST = 'UPDATE_REFERENT_REQUEST';
export const UPDATE_REFERENT_SUCCESS = 'UPDATE_REFERENT_SUCCESS';
export const UPDATE_REFERENT_FAILURE = 'UPDATE_REFERENT_FAILURE';

export const DELETE_REFERENT_REQUEST = 'DELETE_REFERENT_REQUEST';
export const DELETE_REFERENT_SUCCESS = 'DELETE_REFERENT_SUCCESS';
export const DELETE_REFERENT_FAILURE = 'DELETE_REFERENT_FAILURE';

export const FETCH_ONBOARDINGUSER_REQUEST = 'FETCH_ONBOARDINGUSER_REQUEST';
export const FETCH_ONBOARDINGUSER_SUCCESS = 'FETCH_ONBOARDINGUSER_SUCCESS';
export const FETCH_ONBOARDINGUSER_FAILURE = 'FETCH_ONBOARDINGUSER_FAILURE';

export const UPDATE_ONBOARDINGUSER_REQUEST = 'UPDATE_ONBOARDINGUSER_REQUEST';
export const UPDATE_ONBOARDINGUSER_SUCCESS = 'UPDATE_ONBOARDINGUSER_SUCCESS';
export const UPDATE_ONBOARDINGUSER_FAILURE = 'UPDATE_ONBOARDINGUSER_FAILURE';

export const FETCH_ONBOARDINGUSER_ADDRESS_REQUEST = 'FETCH_ONBOARDINGUSER_ADDRESS_REQUEST';
export const FETCH_ONBOARDINGUSER_ADDRESS_SUCCESS = 'FETCH_ONBOARDINGUSER_ADDRESS_SUCCESS';
export const FETCH_ONBOARDINGUSER_ADDRESS_FAILURE = 'FETCH_ONBOARDINGUSER_ADDRESS_FAILURE';

export const UPDATE_ONBOARDINGUSER_ADDRESS_REQUEST = 'UPDATE_ONBOARDINGUSER_ADDRESS_REQUEST';
export const UPDATE_ONBOARDINGUSER_ADDRESS_SUCCESS = 'UPDATE_ONBOARDINGUSER_ADDRESS_SUCCESS';
export const UPDATE_ONBOARDINGUSER_ADDRESS_FAILURE = 'UPDATE_ONBOARDINGUSER_ADDRESS_FAILURE';

export const UPDATE_ONBOARDINGSTEP_REQUEST = 'UPDATE_ONBOARDINGSTEP_REQUEST';
export const UPDATE_ONBOARDINGSTEP_SUCCESS = 'UPDATE_ONBOARDINGSTEP_SUCCESS';
export const UPDATE_ONBOARDINGSTEP_FAILURE = 'UPDATE_ONBOARDINGSTEP_FAILURE';

export const REPRESENTATIVE_INVITATION_REQUEST = 'REPRESENTATIVE_INVITATION_REQUEST';
export const REPRESENTATIVE_INVITATION_SUCCESS = 'REPRESENTATIVE_INVITATION_SUCCESS';
export const REPRESENTATIVE_INVITATION_FAILURE = 'REPRESENTATIVE_INVITATION_FAILURE';